import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {paths} from "./paths";
import {SvgIcon} from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ListAltIcon from "@mui/icons-material/ListAlt";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import {useAuth} from "./hooks/auth/use-auth";
import MessageChatSquareIcon from 'src/icons/untitled-ui/duocolor/message-chat-square';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
export const AppMenu = () => {
    const {t} = useTranslation();
    let permission = useAuth().getPermission()
    const isMenuVisible = (key) => {
        return permission && permission[key] === 1;
    }
    return useMemo(() => {
        const sections = [
            {
                items: isMenuVisible('menu_callcenter') ? [
                    {
                        title: 'Call Center',
                        path: paths.callCenter.index,
                        key: 'menu_callcenter',
                        icon: (
                            <SvgIcon fontSize="small">
                                <SupportAgentIcon/>
                            </SvgIcon>
                        )
                    },
                ] : []
            },
            {
                items: isMenuVisible('menu_crm') ? [
                    {
                        title: 'CRM',
                        path: paths.crm.index,
                        key: 'menu_crm',
                        icon: (
                            <SvgIcon fontSize="small">
                                <ScreenSearchDesktopIcon/>
                            </SvgIcon>
                        )
                    },
                ] : []
            },
            {
                items: isMenuVisible('menu_monitor') ? [
                    {
                        title: 'Monitor',
                        path: paths.monitor.index,
                        key: 'menu_monitor',
                        icon: (
                            <SvgIcon fontSize="small">
                                <MyLocationIcon/>
                            </SvgIcon>
                        )
                    },
                ] : []
            },
            {
                items: isMenuVisible('menu_supervisor') ? [
                    {
                        title: 'Supervisor',
                        path: paths.supervisor.index,
                        key: 'menu_supervisor',
                        icon: (
                            <SvgIcon fontSize="small">
                                <ListAltIcon/>
                            </SvgIcon>
                        )
                    },
                ] : []
            },
            {
                items: isMenuVisible('menu_oss_supervisor') ? [
                    {
                        title: 'OSS Supervisor',
                        path: paths.ossSupervisor.index,
                        key: 'menu_oss_supervisor',
                        icon: (
                            <SvgIcon fontSize="small">
                                <ListAltIcon/>
                            </SvgIcon>
                        )
                    },
                ] : []
            },

            {
                items: isMenuVisible('menu_report') ? [
                    {
                        title: 'Report',
                        path: paths.report.index,
                        key: 'menu_report',
                        icon: <SummarizeIcon/>,
                        items: [
                            {
                                title: 'Summary Report',
                                path: paths.report.summaryReport
                            },
                            {
                                title: 'Surveyor Report',
                                path: paths.report.surveyorReport
                            },
                            {
                                title: 'Claim Report',
                                path: paths.report.claimReport
                            },
                            {
                                title: 'Enquiry Report',
                                path: paths.report.enquiryReport
                            },
                            {
                                title: 'Close Claim Report',
                                path: paths.report.closeClaimReport
                            },
                            {
                                title: 'Monitor Report',
                                path: paths.report.monitor
                            },
                        ]
                    },
                ] : []
            },
            {
                items: isMenuVisible('menu_system') ? [
                    {
                        title: 'Administrator',
                        path: paths.administrator.index,
                        key: 'menu_system',
                        icon: <AdminPanelSettingsIcon/>,
                        items: [
                            {
                                title: 'Manage User',
                                path: paths.administrator.user
                            },
                            {
                                title: 'Manage Outsource',
                                path: paths.administrator.outsource
                            },
                            {
                                title: 'Manage Outsource Zone',
                                path: paths.administrator.outsourceZone
                            },
                            {
                                title: 'Manage Company',
                                path: paths.administrator.company
                            },
                            {
                                title: 'Manage Role',
                                path: paths.administrator.role
                            },
                        ]
                    },
                ] : []
            },
        ]
        return sections.filter(section => section.items.length > 0);
    }, [t, permission]);
}